export default __webpack_public_path__ + "72e485b44924a6965512d80b13d0b721.svg";